import { resolveEntityPath } from "./resolveEntityPath";

export const ENTITY_EDIT_PATHS = {
  debitNote: "/m/gi/debitNote",
  order: "/account/order",
  renewal: "/m/gi/renewal",
  client: "/account/client",
};

export function buildEntityEditHref(entity, id, { userRole, currentPathname } = {}) {
  if (!entity || !id) return null;
  const pathname =
    entity === "debitNote"
      ? ENTITY_EDIT_PATHS.debitNote
      : resolveEntityPath(entity, userRole, currentPathname) ||
        ENTITY_EDIT_PATHS[entity];
  if (!pathname) return null;
  return `${pathname}?id=${id}&mode=edit`;
}

const decodeHref = (href = "") => String(href).replace(/&amp;/g, "&").trim();

const innerText = (html = "") =>
  String(html)
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

const shouldRewriteHref = ({ entityName, entityCode, text, href }) => {
  if (!href && !text) return false;
  if (entityCode && text === entityCode) return true;
  if (entityCode && (href === entityCode || href.endsWith(entityCode))) return true;
  const path = ENTITY_EDIT_PATHS[entityName];
  if (path && href.includes(path)) return true;
  if (entityName && href.includes(`/${entityName}`)) return true;
  return false;
};

const replaceHrefAttr = (attrs, entityUrl) => {
  if (/\bhref\s*=\s*["']/i.test(attrs)) {
    return attrs.replace(/\bhref\s*=\s*(["'])[\s\S]*?\1/i, `href="${entityUrl}"`);
  }
  if (/\bhref\s*=/i.test(attrs)) {
    return attrs.replace(/\bhref\s*=\s*[^\s>]+/i, `href="${entityUrl}"`);
  }
  return `href="${entityUrl}" ${attrs}`.trim();
};

export function rewriteEntityLinks(html, { entityName, entityCode, entityUrl } = {}) {
  if (!html || !entityUrl) return html ?? "";
  return String(html).replace(/<a\s+([^>]*?)>([\s\S]*?)<\/a>/gi, (full, attrs, inner) => {
    const hrefMatch =
      attrs.match(/\bhref\s*=\s*(["'])([\s\S]*?)\1/i) ||
      attrs.match(/\bhref\s*=\s*([^\s>]+)/i);
    const href = decodeHref(hrefMatch ? hrefMatch[2] ?? hrefMatch[1] : "");
    const text = innerText(inner);
    if (!shouldRewriteHref({ entityName, entityCode, text, href })) {
      return full;
    }
    return `<a ${replaceHrefAttr(attrs, entityUrl)}>${inner}</a>`;
  });
}

export function isEntityRecordLink({ href, text, entityCode, entityName }) {
  const decoded = decodeHref(href);
  const label = String(text ?? "").trim();
  return shouldRewriteHref({
    entityName,
    entityCode,
    text: label,
    href: decoded,
  });
}
